import { gql } from '@apollo/client';

export const getExtendCalculatedHostPlans = gql`
  query getExtendCalculatedHostPlans {
    getExtendCalculatedHostPlans {
      planId
    }
  }
`;
